import { mString } from 'lib/helpers/utility';

import DrAvatar from './lib/components/DrAvatar';
import SlideHeader from './lib/components/SlideHeader';
import SpeechBubble from './lib/components/SpeechBubble';

const TOC_ITEMS = [
  { label: 'Services', desc: 'What you are being treated for' },
  { label: 'Coverage', desc: 'What your insurance covers' },
  { label: 'Your Balance', desc: 'What you owe and why' },
  { label: 'Definitions', desc: 'Insurance terms explained' }
];

const WelcomePage = ({ estimate }) => (
  <div className="flex flex-col gap-5">
    <SlideHeader title="Understanding your visit costs" />

    <div className="flex flex-col items-center gap-2">
      <div className="rounded-xl bg-gradient-to-r from-success-50 to-success-100 px-8 py-3 shadow-sm">
        <span className="text-3xl font-800 tracking-tight text-success-700">
          {mString(estimate?.patientResponsibility ?? 0)}
        </span>
      </div>
      <p className="text-center text-sm font-500 text-neutral-700">
        This is your estimated out-of-pocket cost for today's visit.
      </p>
      <div className="rounded-lg border border-dashed border-primary-300 bg-primary-25 px-5 py-2">
        <p className="text-center text-sm font-500 text-primary-700">
          For more information, please continue reading.
        </p>
      </div>
    </div>

    <div className="flex items-end gap-4">
      <DrAvatar size="small" variant={1} className="shrink-0" />
      <SpeechBubble variant="highlight" tail="left">
        Welcome! I'm here to walk you through what your visit will cost — and why.
      </SpeechBubble>
    </div>

    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#D6F0FB] via-[#E2F4FC] to-[#EAF7FD]">
      <div className="absolute bottom-0 left-0 right-0 top-0 opacity-[0.07]">
        <svg viewBox="0 0 600 300" className="h-full w-full" preserveAspectRatio="xMidYMax slice">
          <path d="M80 300 L80 120 Q85 100 95 110 L95 300Z" fill="#0093C4" />
          <path d="M100 300 L100 80 Q110 60 120 80 L120 300Z" fill="#0093C4" />
          <path d="M130 300 L130 140 Q135 125 145 135 L145 300Z" fill="#0093C4" />
          <path d="M60 300 L60 160 Q65 150 75 155 L75 300Z" fill="#0093C4" />
          <circle cx="90" cy="70" r="30" fill="#0093C4" />
          <circle cx="120" cy="50" r="35" fill="#0093C4" />
          <circle cx="70" cy="100" r="20" fill="#0093C4" />
          <circle cx="140" cy="90" r="18" fill="#0093C4" />
          <path d="M400 300 L400 100 Q410 80 420 100 L420 300Z" fill="#0093C4" />
          <path d="M430 300 L430 130 Q435 115 445 125 L445 300Z" fill="#0093C4" />
          <circle cx="410" cy="60" r="35" fill="#0093C4" />
          <circle cx="440" cy="85" r="22" fill="#0093C4" />
        </svg>
      </div>

      <div className="relative flex items-end gap-4 px-6 py-6 sm:flex-col sm:items-center">
        <div className="flex-1">
          <p className="text-sm leading-[1.8] text-neutral-700">
            Healthcare costs can feel confusing. We'll break down each piece — what your insurance
            covers, what you owe, and where the numbers come from.
            <br />
            <br />
            We'll use a few common insurance terms along the way. Don't worry if any are new to you
            — there's a glossary at the end that explains every one in plain language.
          </p>
        </div>
        <DrAvatar size="medium" variant={4} className="shrink-0" />
      </div>
    </div>

    <div className="overflow-hidden rounded-xl border border-solid border-neutral-200 shadow-sm">
      <div className="bg-neutral-50 px-4 py-2.5">
        <p className="text-center text-sm font-700 text-primary-900">Table of Contents</p>
      </div>
      <div className="grid grid-cols-4 divide-x divide-neutral-100 md:grid-cols-2 md:divide-y sm:grid-cols-1 sm:divide-x-0 sm:divide-y">
        {TOC_ITEMS.map((item) => (
          <div key={item.label} className="flex flex-col items-center gap-0.5 bg-white px-2 py-3">
            <span className="text-sm font-600 text-primary-600">{item.label}</span>
            <span className="text-center text-sm leading-tight text-neutral-400">{item.desc}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default WelcomePage;
